import React, { Component } from 'react'
import { Col, Row } from 'react-flexbox-grid'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import { withStyles } from '@material-ui/core/styles'
import TitledLabel from '../../../controls/TitledLabel'
import Columns from '../../../styles/columns'
import CardStyles from '../../../styles/cards'
import MemberBenefitCardHeaderStyles from '../../../styles/components/member-benefit-card-header'
import { localize } from '../../../util/Localizer'
import NgrxDate from '../../../util/NgrxDateHelper'
import CollapsibleSection from '../../../controls/CollapsibleSection'
import RBButton from '../../../controls/RBButton'
import { push } from 'connected-react-router'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'

class ClaimsHistory extends Component {
  constructor () {
    super()
    this.showAssociatedClaim = this.showAssociatedClaim.bind(this)
  }

  showAssociatedClaim (claim) {
    this.props.push(`/Claims/${claim.claimId}/Claim/ClaimLines`)
  }

  render () {
    const { claimsHistory, classes } = this.props
    return (
      <CollapsibleSection
        id='claimsHistory'
        showMuiBorder={false}
        heading={localize('pages.hcsa.claimsHistory')}
        expanded={false}>
        {claimsHistory.map((claim, index) => {
          let dateOfService
          let dateOfServiceFormat
          if (claim.datesOfService) {
            if (claim.datesOfService.length > 1) {
              dateOfService = localize('pages.claims.multiple')
              dateOfServiceFormat = 'Text'
            } else {
              dateOfService = claim.datesOfService[0]
              dateOfServiceFormat = 'date'
            }
          }
          return (
            <Card key={index} className={classes.hcsaCard}>
              <CardHeader classes={{ root: classes.root, title: classes.title }} title={localize('pages.hcsa.claimHist.claimNumber') + ' : ' + claim.claimNumber} />

              <Row >
                <Col {...Columns.max6}>
                  <TitledLabel title='pages.hcsa.claimHist.processedDate' value={NgrxDate.SetDate(claim.processedDate)} />
                </Col>
                <Col {...Columns.max6}>
                  <TitledLabel title='pages.hcsa.claimHist.dateOfService' value={dateOfService} format={dateOfServiceFormat} />
                </Col>
                <Col {...Columns.max6}>
                  <TitledLabel title='pages.hcsa.claimHist.status' value={claim.status} />
                </Col>
                <Col {...Columns.max6}>
                  <TitledLabel title='pages.hcsa.claimHist.amountPaid' value={claim.amountPaid} format='currency' />
                </Col>
                <Col {...Columns.max6}>
                  <TitledLabel title='pages.hcsa.claimHist.benefit' value={claim.benefit} />
                </Col>
                <Col {...Columns.max6} className={'buttonRow'}>
                  <RBButton variant='outlined' className='claimButtonResponsive' onClick={() => this.showAssociatedClaim(claim)} label={localize('pages.hcsa.claimHist.viewClaims')} />
                </Col>
              </Row>
            </Card>
          )
        })}

      </CollapsibleSection>
    )
  }
}

function mapStateToProps (state) {
  return {
  }
}

const ConnectedClaimsHistory = connect(mapStateToProps, { push })(injectIntl(ClaimsHistory))

const styles = theme => ({
  ...MemberBenefitCardHeaderStyles(theme),
  ...CardStyles
})

export default withStyles(styles)(ConnectedClaimsHistory)



// WEBPACK FOOTER //
// ./src/widgets/Member/Hsca/ClaimsHistory.js